import React from 'react';
import PropTypes from 'prop-types';
import {
    MediaObject,
    Avatar,
    Paragraph,
    IconUser,
} from '@zillow/constellation';

const ArticleAuthor = ({ avatar, name, jobTitle, publishDate }) => {
    const publishDateObject = new Date(publishDate);

    return (
        <MediaObject
            media={<Avatar size="lg">{avatar || <IconUser />}</Avatar>}
            align="center"
        >
            <Paragraph fontType="bodySmallHeading" fontColor="blue600">
                Written by
            </Paragraph>
            {!!name && (
                <Paragraph fontType="bodySmall" fontColor="blue400">
                    {name}
                </Paragraph>
            )}
            {!!jobTitle && (
                <Paragraph fontType="bodySmall" fontColor="textMedium">
                    {jobTitle}
                </Paragraph>
            )}
            <Paragraph fontType="bodySmall" fontColor="textMedium">{`${String(
                publishDateObject.getMonth() + 1
            ).padStart(2, '0')}.${String(publishDateObject.getDate()).padStart(
                2,
                '0'
            )}.${String(publishDateObject.getFullYear()).substring(
                -2
            )}`}</Paragraph>
        </MediaObject>
    );
};

ArticleAuthor.propTypes = {
    name: PropTypes.string,
    jobTitle: PropTypes.string,
    avatar: PropTypes.node,
    publishDate: PropTypes.string.isRequired,
};

ArticleAuthor.defaultProps = {};

export default ArticleAuthor;
